<template>
 <section id="recentLcReportsslide">
  <section v-for="(photo,index) in value" :key="'photo' + index" data-transition="convex" data-autoslide="3000" >
    <div
      class="sl-block"
      data-block-type="text"
      style="width: 100%; left: 29px; top: 84px; height: auto"
    >
      <div
        class="sl-block-content"
        data-placeholder-tag="h2"
        data-placeholder-text="Title Text"
        style="text-align: left; z-index: 10"
        dir="ui"
      >
        <h2 style="text-align: center; font-family: Poppins">Recent Photos</h2>
      </div>
    </div>

    <div
      class="sl-block"
      data-block-type="table"
      style="
        height: auto;
        min-width: 120px;
        width: 100%;
        left: 29px;
        top: 175.5px;
        min-height: 450px;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
     <div class="figure">
         <img class="imageFrame" :data-src="photo.url" />
         <div style="margin-top: 10px; color: black; text-align:center; font-family: Comic Sans MS; font-size: 0.5em;">{{photo.platformGroupName}} - {{photo.date}}</div>
     </div>
    </div>
  </section>
  </section>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "",
  props: ["value"],
  components: {},
  beforeMount() {},
  mounted() {},
  data() {
    return {
      moment: moment,
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  methods: {},
};
</script>
<style lang="scss">


#recentLcReportsslide {
 .imageFrame {
    width: 100%; 
    height: 450px; 
    border: 1px solid silver;
    
 }

  .figure {
    display: inline-block;
    background-color: white;
    margin: 10px;
  
    position: absolute;
    top: 90px;
   
    width: 693px;
    padding: 20px;
  }
  
}
</style>

